module.exports = __webpack_public_path__ + "static/media/showoff-2.c3f646c9.png";